/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Drag Icon component.
 */
export const DragIcon = ({color = dlsColor('grey3')}: IconProps) => {
  const {iconColor} = useIconDLS({color});
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10 9.99951C10.55 9.99951 11 10.4495 11 10.9995C11 11.5495 10.55 11.9995 10 11.9995C9.45003 11.9995 9.00003 11.5495 9.00003 10.9995C9.00003 10.4495 9.45003 9.99951 10 9.99951ZM10 6.99951C10.55 6.99951 11 7.44951 11 7.99951C11 8.54951 10.55 8.99951 10 8.99951C9.45003 8.99951 9.00003 8.54951 9.00003 7.99951C9.00003 7.44951 9.45003 6.99951 10 6.99951ZM10 3.99951C10.55 3.99951 11 4.44951 11 4.99951C11 5.54951 10.55 5.99951 10 5.99951C9.45003 5.99951 9.00003 5.54951 9.00003 4.99951C9.00003 4.44951 9.45003 3.99951 10 3.99951Z' fill={iconColor} />
      <path d='M6.50003 6.00049C5.95003 6.00049 5.50003 5.55049 5.50003 5.00049C5.50003 4.45049 5.95003 4.00049 6.50003 4.00049C7.05003 4.00049 7.50003 4.45049 7.50003 5.00049C7.50003 5.55049 7.05003 6.00049 6.50003 6.00049ZM6.50003 9.00049C5.95003 9.00049 5.50003 8.55049 5.50003 8.00049C5.50003 7.45049 5.95003 7.00049 6.50003 7.00049C7.05003 7.00049 7.50003 7.45049 7.50003 8.00049C7.50003 8.55049 7.05003 9.00049 6.50003 9.00049ZM6.50003 12.0005C5.95003 12.0005 5.50003 11.5505 5.50003 11.0005C5.50003 10.4505 5.95003 10.0005 6.50003 10.0005C7.05003 10.0005 7.50003 10.4505 7.50003 11.0005C7.50003 11.5505 7.05003 12.0005 6.50003 12.0005Z' fill={iconColor} />
    </svg>
  );
};

export default DragIcon;
